var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative w-full pb-9/16"},[_c('iframe',{staticClass:"absolute h-full w-full left-0 top-0",attrs:{"title":"About SlidesLive","src":"https://player.vimeo.com/video/553288288","frameborder":"0","allow":"autoplay; fullscreen","allowfullscreen":""}})])
}]

export { render, staticRenderFns }